// extracted by mini-css-extract-plugin
export default {"stackContainer":"PokerChipStack_stackContainer__+UOoZ","chipWrapper":"PokerChipStack_chipWrapper__3ESgf"};